(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iw-product-inquiry"] && !Shopify.designMode) return;
  try {
    
function iwPrefillAcDcSet() {
  if (new URLSearchParams(window.location.search).get('set') !== 'stingray-one-acdc') return;
  const select = document.getElementById('iwc-product-inquiry-format');
  const model = document.getElementById('iwc-product-inquiry-model');
  if (select && !select.value) {
    const option = [...select.options].find(item => item.dataset.iwcValue === 'acdc-set');
    if (option) select.value = option.value;
  }
  if (model && !model.value) model.value = 'GYS PROTIG 201 AC/DC HF FV + STINGRAY ONE';
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iwPrefillAcDcSet, {once: true});
else iwPrefillAcDcSet();
document.addEventListener('shopify:section:load', iwPrefillAcDcSet);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-product"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-iw-variant]')) return;
  const scope = event.target.closest('.iw-product-main');
  const option = event.target.selectedOptions[0];
  if (!scope || !option) return;
  const price = scope.querySelector('[data-iw-price]');
  const net = scope.querySelector('[data-iw-net]');
  const button = scope.querySelector('[data-iw-buy]');
  if (price) price.textContent = option.dataset.price;
  if (net) net.textContent = option.dataset.net || '';
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.buy : button.dataset.unavailable;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
